<template>
	<div class="rounded-md bg-red-50 p-4">
		<div class="flex">
			<div class="flex-shrink-0">
				<ui-icon
					name="alert-triangle"
					class="h-5 w-5 text-red-400"
					aria-hidden="true"
				/>
			</div>
			<div class="ml-3">
				<h3 class="text-sm font-medium text-red-800">
					{{ __("There were errors with your submission") }}:
				</h3>
				<div class="mt-2 text-sm text-red-700">
					<ul role="list" class="list-disc pl-5 space-y-1">
						<li v-for="(message, idx) in messages" :key="idx">
							{{ message }}
						</li>
					</ul>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	props: {
		messages: {
			type: Array,
			required: true,
		},
		type: {
			type: String,
			default: "danger",
		},
	},
};
</script>
